export default {

  // 创建信令通道（批量）
  createVideoChannel: '/backstageApi/account/backstage/videoChannel/createVideoChannel',
  // 获取信令通道列表
  getListSignalingChannels: '/backstageApi/account/backstage/videoChannel/getListSignalingChannels',
  // 获取信令通道地区
  getSignalingRegion: '/backstageApi/account/backstage/videoChannel/getSignalingRegion',
  // 更新信令通道
  updateSignaling: '/backstageApi/account/backstage/videoChannel/updateSignaling',
  // 删除信令通道
  deleteSignaling: '/backstageApi/account/backstage/videoChannel/deleteSignaling',
  // 获取服务器所在区域
  getSignalingRegionList: '/backstageApi/account/backstage/videoChannel/signalingRegionList',
  // 新增服务器所在区域
  insertSignalingServiceRegion: '/backstageApi/account/backstage/videoChannel/insert',
  // 更新服务器所在区域
  updateSignalingServiceRegion: '/backstageApi/account/backstage/videoChannel/update',
  // 删除服务器所在区域
  deleteByIdSignalingServiceRegion: '/backstageApi/account/backstage/videoChannel/deleteById',
  // 获取服务所在区域分页列表
  signalingSelectListPage: '/backstageApi/account/backstage/videoChannel/selectListPage',
  // 国家检测
  checkCountry: '/backstageApi/account/backstage/videoChannel/checkCountry',
  // 新增p2p区域
  insertPeerToPeerProviderRegion: '/backstageApi/account/backstage/peerToPeerProviderRegion/insert',
  // 更新p2p区域
  updatePeerToPeerProviderRegion: '/backstageApi/account/backstage/peerToPeerProviderRegion/update',
  // p2p区域列表
  peerToPeerProviderRegionList: '/backstageApi/account/backstage/peerToPeerProviderRegion/peerToPeerProviderRegionList',
  // p2p分页列表
  peerToPeerProviderRegionListPage: '/backstageApi/account/backstage/peerToPeerProviderRegion/selectListPage',
  // p2pUid分页列表
  peerToPeerUidListPage: '/backstageApi/account/backstage/peerToPeerUid/selectByPage',
  // p2pUIdLog分页列表
  peerToPeerUidLogListPage: '/backstageApi/account/backstage/peerToPeerUid/selectLogByPage',
  // p2p通道隔离
  isolatePtopUid: '/backstageApi/account/backstage/usercenter/device/isolatePtopUid'
}



// WEBPACK FOOTER //
// ./src/api/aws/aws.js